export const VIBE_USERNAME_MAX_LENGTH = 16;

// URL-safe characters: alphanumeric, hyphen, underscore
// This regex allows: a-z, A-Z, 0-9, -, _
const VIBE_USERNAME_PATTERN = /^[a-zA-Z0-9_-]+$/;

export function truncateVibeUsername(value, maxLength = VIBE_USERNAME_MAX_LENGTH) {
    if (value == null) {
        return value;
    }
    const stringValue = String(value);
    const chars = Array.from(stringValue);
    if (chars.length <= maxLength) {
        return stringValue;
    }
    return `${chars.slice(0, maxLength).join('')}...`;
}

export function validateVibeUsername(username) {
    if (!username || username.trim() === '') {
        return true; // Empty is allowed (optional field)
    }
    const trimmed = username.trim();
    if (!VIBE_USERNAME_PATTERN.test(trimmed)) {
        return 'Username can only contain letters, numbers, hyphens, and underscores';
    }
    return true;
}
